<template>
  <vs-popup
    :active.sync="modalAtivo"
    title="Informações Financeiras"
    @close="fecharModal"
    id="popup-informacoes-financeiras"
  >
    <form @submit.stop.prevent="emitForm()">
      <!-- Gera Cobrança -->
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <span>Gera Cobrança?</span>
          <vs-switch
            color="success"
            v-model="form.geraCobranca"
            style="width: 60px"
            :disabled="!permissaoAlterarDadosCobranca"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <span>Valor de Mensalidade</span>
          {{ valorProdutos | currency }}
        </div>
      </div>
      <div class="vx-row mb-4">
        <!-- Carteira de Cobrança -->
        <div class="vx-col w-full">
          <label for="Carteira de Cobrança" class="vs-select--label">
            Carteira de Cobrança
          </label>

          <v-select
            :options="listCarteiraCobranca"
            name="Carteira de Cobrança"
            id="Carteira de Cobrança"
            label="label"
            v-model="form.idCarteiraCobranca"
            :disabled="!permissaoAlterarDados"
            class="select-large w-full"
            :reduce="(item) => item.id"
            @input="selecionaFormaPagamento()"
            v-validate="{ required: true }"
            :state="
              utils.validateState(
                this.veeFields,
                this.veeErrors,
                'Carteira de Cobrança',
              )
            "
            :danger="
              utils.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Carteira de Cobrança',
              )
            "
          ></v-select>
        </div>
      </div>
      <vs-card v-if="carteiraSelecionada && carteiraSelecionada.shortName">
        <div class="vx-row my-4">
          <div v-if="carteiraSelecionada.shortName" class="vx-col sm:w-1/3">
            <b>Banco:</b> {{ carteiraSelecionada.shortName }}
          </div>
          <div v-if="carteiraSelecionada.agencia" class="vx-col sm:w-1/3">
            <b>Agência:</b> {{ carteiraSelecionada.agencia }}
          </div>
          <div v-if="carteiraSelecionada.conta" class="vx-col sm:w-1/3">
            <b>Conta:</b> {{ carteiraSelecionada.conta }} -
            {{ carteiraSelecionada.digitoConta }}
          </div>
        </div>
      </vs-card>

      <div class="vx-row mb-4">
        <!-- Dia de Vencimento -->
        <div class="vx-col sm:w-1/2 w-full">
          <label for="Dia de Vencimento" class="vs-select--label">
            Dia de Vencimento
          </label>
          <v-select
            :options="[...diasDeVencimentoEmpresa]"
            name="Dia de Vencimento"
            id="Dia de Vencimento"
            label="item"
            :disabled="!permissaoAlterarDados"
            v-model="form.diaVencimento"
            class="select-large w-full"
            v-validate="{ required: true }"
            :state="
              utils.validateState(
                this.veeFields,
                this.veeErrors,
                'Dia de Vencimento',
              )
            "
            :danger="
              utils.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Dia de Vencimento',
              )
            "
          ></v-select>
        </div>

        <!-- Forma de Pagamento -->
        <div class="vx-col sm:w-1/2 w-full">
          <label for="Forma de Pagamento Mensal" class="vs-select--label">
            Forma de Pagamento Mensal
          </label>

          <v-select
            :options="formasDePagamento"
            name="Forma de Pagamento Mensal"
            id="Forma de Pagamento Mensal"
            label="label"
            v-model="form.idTipoPagamentoMensal"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :disabled="!permissaoAlterarDados"
            v-validate="{ required: true }"
            :state="
              utils.validateState(
                this.veeFields,
                this.veeErrors,
                'Forma de Pagamento Mensal',
              )
            "
            :danger="
              utils.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Forma de Pagamento Mensal',
              )
            "
          ></v-select>
        </div>
      </div>
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row mt-3 mb-4">
        <div class="vx-col sm:w-1/1 w-full text-right">
          <vs-button
            color="success"
            type="gradient"
            class="mr-3 mb-2"
            v-if="permissaoAlterarDados"
            @click="salvarDados"
            >Salvar</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>

<script>
import services from '../../services';
import utils from './../../utils/list/index';
import vSelect from 'vue-select';

export default {
  props: [
    'popupActive',
    'dataInformacoesFinanceiras',
    'formasPagamentos',
    'diasDeVencimentoEmpresa',
  ],
  components: {
    'v-select': vSelect,
  },
  watch: {
    popupActive() {
      if (this.popupActive) {
        this.modalAtivo = true;
        // start
      }
    },
    dataInformacoesFinanceiras(value) {
      if (value) {
        console.log('dataInformacoesFinanceiras', value);
        this.form.geraCobranca = value.geraCobranca;
        this.form.diaVencimento = value.diaVencimento;
        this.form.idTipoPagamentoMensal = value.id_TipoPagamentoMensal;
        this.form.idVeiculo = value.id_veiculo;
        this.form.idCarteiraCobranca = value.idCarteira;
        this.valorProdutos = value.valorProdutos;
        this.selecionaFormaPagamento();
      }
    },
  },
  data() {
    return {
      permissaoAlterarDados: this.$can('Editar Dados', 'Veículos'),
      modalAtivo: false,
      form: {
        geraCobranca: false,
        diaVencimento: null,
        idTipoPagamentoMensal: null,
        idCarteiraCobranca: null,
      },
      permissaoAlterarDadosCobranca: this.$can(
        'Editar Dados Cobrança',
        'Veículos',
      ),
      listCarteiraCobranca: [],
      carteiraSelecionada: null,
      formasDePagamento: [],
      valorProdutos: 0,
      utils,
    };
  },
  mounted() {
    this.loadCarteiraCobranca();
  },
  methods: {
    salvarDados() {},
    fecharModal() {
      this.$emit('close');
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.classList.add('style-chooser');
      // ...  adjust the position
    },
    selecionaFormaPagamento() {
      console.log(this.form.idCarteiraCobranca);
      console.log(this.listCarteiraCobranca);
      const carteiraSelecionada = this.listCarteiraCobranca.find(
        (x) => x.id == this.form.idCarteiraCobranca,
      );
      console.log(carteiraSelecionada);
      this.carteiraSelecionada = carteiraSelecionada;
      const listFormas = [];
      carteiraSelecionada.formasPagamento.forEach((element) => {
        listFormas.push({
          id: element.id_tipoPagamentoEmpresa,
          label: element.nomePagamento,
        });
      });
      this.formasDePagamento = listFormas;

      if (this.form.idTipoPagamentoMensal) {
        const isInFormas = listFormas.find(
          (x) => x.id == this.form.idTipoPagamentoMensal,
        );
        if (!isInFormas) this.form.idTipoPagamentoMensal = null;
        else
          this.form.idTipoPagamentoMensal =
            this.dataInformacoesFinanceiras.id_TipoPagamentoMensal;
      }
    },
    async loadCarteiraCobranca() {
      try {
        const response = await services.getAll(
          'Financeiro',
          null,
          'lista-carteira-cobranca',
        );
        const { data } = response;

        data.forEach((element) => {
          let obj = { ...element };
          obj.id = element.idCarteira;
          obj.label = element.nomeCarteira;
          obj.formasPagamento = JSON.parse(element.formasPagamento);
          this.listCarteiraCobranca.push(obj);
        });
        console.log(this.listCarteiraCobranca);
      } catch (error) {
        console.log(error);
      }
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var newForm = {
            veiculo: {},
          };
          Object.keys(this.form).forEach((element) => {
            if (
              (typeof this.form[element] != 'object' &&
                typeof this.form[element] != 'undefined') ||
              typeof this.form[element] === 'boolean'
            ) {
              if (
                this.form[element] != this.dataInformacoesFinanceiras[element]
              ) {
                newForm[element] = this.form[element];
              }
            }
          });
          console.log(newForm);
          this.$emit('formAlterado', newForm);
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
#popup-informacoes-financeiras {
  .vs-popup--header {
    background: #008fcd;

    .vs-popup--title h3 {
      color: white;
    }
  }
}
</style>
